module.exports = __webpack_public_path__ + "static/media/index.34b9cfbb.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/message/style/index.less
// module id = 857
// module chunks = 0